module.exports = __webpack_public_path__ + "img/mobile.a1ff974d.png";